// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { BlockedReasonSchema } from '../inputTypeSchemas/BlockedReasonSchema'
import { AdaptiveScanningObservationSourceSchema } from '../inputTypeSchemas/AdaptiveScanningObservationSourceSchema'

/////////////////////////////////////////
// ADAPTIVE SCANNING BLOCK OBSERVATION SCHEMA
/////////////////////////////////////////

export const AdaptiveScanningBlockObservationSchema = z.object({
  reason: BlockedReasonSchema.nullable(),
  source: AdaptiveScanningObservationSourceSchema,
  id: z.string(),
  tenantId: z.string(),
  applicationId: z.string(),
  signalId: z.string().nullable(),
  observedAt: z.coerce.date(),
  metadata: JsonValueSchema.nullable(),
})

export type AdaptiveScanningBlockObservation = z.infer<typeof AdaptiveScanningBlockObservationSchema>

export default AdaptiveScanningBlockObservationSchema;
